module.exports = __webpack_public_path__ + "media/nice_drum_room.9692e08d.wav";